function wu_sidebar_news_toggle() {

	$('.sidebar-news-toggles a').on('click touch', function(e){
		e.preventDefault();

		var l = $(this).data('list');

		$('.news-toggle-active').removeClass('news-toggle-active');
		$(this).addClass('news-toggle-active');
		$('.news-taxonomies,.news-popular').addClass('hide');
		$('#'+l).removeClass('hide');

	})

}

wu_sidebar_news_toggle();